import { Component, inject, signal } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { PayeeHeaderComponent } from '../../../shared/payee-header/payee-header.component';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../../shared/payee-input/payee-input.directive';
import { MatError } from '@angular/material/input';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { FooterSimpleComponent } from '../../../shared/footer-simple/footer-simple.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-get-password-link',
  templateUrl: './get-password-link.component.html',
  styleUrls: ['./get-password-link.component.scss'],
  imports: [
    PayeeHeaderComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeInputDirective,
    MatError,
    PayeeButtonComponent,
    RouterLink,
    FooterSimpleComponent,
    TranslateModule,
  ],
})
export class GetPasswordLinkComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);

  readonly forgotPasswordForm = this.fb.group({
    email: this.fb.control('', {
      validators: [Validators.required, Validators.email],
      nonNullable: true,
    }),
  });

  readonly loading = signal(false);

  get email() {
    return this.forgotPasswordForm.controls.email;
  }

  readonly sendEmail = async (): Promise<void> => {
    if (this.forgotPasswordForm.invalid || this.loading()) {
      return;
    }

    try {
      this.loading.set(true);

      const emailValue = this.email.value;
      await this.authService.sendPasswordResetEmail({
        email: emailValue,
      });

      this.router.navigate(['/forgot-password-get-link-success'], {
        queryParams: {
          email: emailValue,
        },
      });
    } finally {
      this.loading.set(false);
    }
  };
}
